<template>
  <div >

      <vue-countdown-timer
        v-if="!isLoading"
        @start_callback="startCallBack('event started')"
        @end_callback="endCallBack('event ended')"
        :start-time="nextWorshipDate"        
        :interval="1000"        
        label-position="begin"
        :end-text="'Te esperamos en el próximo'"
        :day-txt="'Días'"
        :hour-txt="'Horas'"
        :minutes-txt="'Minutos'"
        :seconds-txt="'Segundos'">


         <template slot="countdown" slot-scope="scope">
          <span style="color:#ddd">
            <span class="text-white">{{scope.props.days}}</span> Días
          </span>
          <span class="ml-1" style="color:#ddd">
            <span class="text-white">{{scope.props.hours}}</span> {{scope.props.hourTxt}}
          </span>
          <span class="ml-1" style="color:#ddd">
            <span class="text-white">{{scope.props.minutes}}</span> {{scope.props.minutesTxt}}
          </span>
          <!-- <span>{{scope.props.seconds}}{{scope.props.secondsTxt}}</span> -->
        </template>
      </vue-countdown-timer>
  </div>
</template>

<script>
import { db } from './../db'

export default {
  data(){
    return {
      isLoading:true,
      nextWorshipDate:null
    }
  },

  mounted(){
    
    db.collection("settings").doc("21dWDhUJmAvAkF4Eb9GL").onSnapshot(res=>{
      this.getData(res)
    })
  },

  methods: {
    startCallBack(x) {
      console.log(x);
    },
    endCallBack(x) {
      console.log(x);
    },    
    async getData(res){      
      this.isLoading = true      
      const data = await res.data()                
      let nextWorship = data.nextWorshipDate.toString()      
      this.nextWorshipDate = nextWorship
      
      setTimeout(() => {                
        this.isLoading = false
      }, 1000);

      const date = new Date()
      console.log(date.toUTCString())
      
    }
  }
}
</script>
